<script setup>
import { computed, ref } from 'vue';
import { sidebar } from '@/config/sidebar';
import { useUserStore } from '@/stores/user';
import CreatePobox from '@/views/pobox/CreatePobox.vue';

const props = defineProps(['show']);
const emit = defineEmits(['update:show']);

const user = useUserStore();
const createPoboxRef = ref(null);

//Use computed property for better reactivity
const showSidebar = computed({
    get: () => props.show,
    set: (value) => emit('update:show', value)
});

const userRoles = useUserStore().data?.roles;

function filterRoles(sidebar, rolesUsuario) {
    return sidebar.system.filter((item) => {
        if (!item.role) return true;
        return item.role.some((rol) => rolesUsuario.includes(rol));
    });
}

const filteredSidebar = filterRoles(sidebar, userRoles).filter((item) => {
    return item.hideInProduction && import.meta.env.VITE_ENV === 'prod'
        ? false
        : true;
});

const isPoboxUser = computed(() => user.data?.user?.type === 'POBOX');

const openMyPobox = () => {
    if (user.data?.pobox) {
        createPoboxRef.value?.open(user.data.pobox);
        showSidebar.value = false;
    }
};
</script>

<template>
    <v-navigation-drawer v-model="showSidebar" temporary>
        <v-list class="sistema-user">
            <template
                v-for="sidebarItem of filteredSidebar"
                :key="sidebarItem.title"
            >
                <template v-if="sidebarItem.subMenu">
                    <v-list-group>
                        <template v-slot:activator="{ props }">
                            <v-list-item
                                v-bind="props"
                                :prepend-icon="sidebarItem.icon"
                                :title="$t(sidebarItem.title)"
                            ></v-list-item>
                        </template>

                        <v-list-item
                            v-for="subMenuItem of sidebarItem.subMenu"
                            :key="subMenuItem.title"
                            :title="$t(subMenuItem.title)"
                            :to="subMenuItem.to"
                        ></v-list-item>
                    </v-list-group>
                </template>
                <template v-else>
                    <v-list-item
                        :prepend-icon="sidebarItem.icon"
                        :title="$t(sidebarItem.title)"
                        :to="sidebarItem.to"
                    ></v-list-item>
                </template>
            </template>

            <v-list-item
                v-if="isPoboxUser"
                prepend-icon="mdi-account-box"
                :title="$t('My Info')"
                @click="openMyPobox"
                class="mt-2"
                style="border-top: 1px solid rgba(0, 0, 0, 0.12)"
            ></v-list-item>
        </v-list>
    </v-navigation-drawer>

    <CreatePobox ref="createPoboxRef" :title="$t('My Info')" />
</template>
